import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { layout, media } from 'src/components/base';
import { TextInput } from 'src/components/inputs';
import { Feedback, Flex, Legal } from 'src/components/newsletter-signup/styles';
import styled from 'styled-components';

export const Button = styled(PrimaryButton)`
  margin-left: ${layout.measurements.spacing100};
  height: 100%;
  width: 100%;
`;

export const InlineInput = styled(TextInput)`
  flex-grow: 1;

  > input {
    height: 100%;
  }

  ${media.smallDown`
      width: 100%
    `}
`;

export const Container = styled.div`
  background: ${p => p.theme.colors.base100};
  padding: ${layout.measurements.spacing150};
  border-radius: ${layout.borderRadius};
  width: 460px;
  display: flex;
  flex-direction: column;
  gap: ${layout.measurements.spacing100};
  margin: 0;

  ${Legal} {
    a {
      color: ${p => p.theme.colors.base600};

      :hover {
        color: ${p => p.theme.colors.base600};
      }
    }
  }
  ${Feedback} {
    color: ${p => p.theme.colors.negative700};
  }
  ${Flex} {
    flex-wrap: nowrap;
    flex-direction: row;
  }

  ${media.smallDown`
    align-items: center;
    gap: ${layout.measurements.spacing150};
    width: 100%;
    justify-content: center;
  `}
`;

export const NewsletterHeader = styled.div`
  > * {
    margin: 0;
  }
  ${media.smallDown`
    flex-grow: 1;
    max-width: 260px;
  `}
`;

export const NewsletterInput = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-grow: 1;

  form {
    margin: 0;
  }

  ${Button} {
    width: unset;

    ${media.smallDown`
      width: 100%;
      margin-left: 0;
      margin-top: ${layout.measurements.spacing100};
    `}
  }

  > form > ${Flex} {
    ${media.smallDown`
      flex-direction: column;
    `}
  }
`;
